import React from 'react';

import {
  AuthorAndTime,
  Title,
  ListElement,
  Card,
  CardData,
  CardHolder,
  StyledLine,
  StyledLineInside,
  FlexContainer,
  Rating
} from '../StyledComponents';
import { rootConfig } from '../../../config/config';
import MainListLoader from '../Loaders/MainListLoader';

const Latest = props => {
  // console.log('props: ', props);
  const { handleLoadMore, contentData, clicked, title, titleProps } = props;

  let cards = null;
  if (contentData) {
    cards = contentData.map(content => {
      return (
        <Card onClick={() => clicked(content.postSlug)} key={content.id}>
          <div className="ImageDiv relative">
            {content.rating ? (
              <FlexContainer className="Rating">
                <Rating
                  className="absolute right-0"
                  width="50px"
                  height="50px"
                  padding="12px"
                  background="#4db2ec"
                >
                  <Title
                    className="Rating-Text"
                    fontFamily="Montserrat"
                    fontWeight="bold"
                    fontSize="1.3rem"
                    color="#fff"
                  >
                    {content.rating}
                  </Title>
                </Rating>
              </FlexContainer>
            ) : null}
            <div
              style={{
                width: '225px',
                height: '112.5px',
                background: `${
                  content.featuredImage
                    ? `url(${rootConfig.imagesRoot}/${
                        content.featuredImage.file
                      })`
                    : `rgba(0, 0, 0, 0.6)`
                }`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center'
              }}
            />
            {/* <img
              src={
                content.featuredImage
                  ? `${rootConfig.imagesRoot}/${content.featuredImage.file}`
                  : null
              }
              alt={content.postSlug}
              className="w-100 mw7 w5-ns"
            /> */}
          </div>
          <CardData>
            <Title
              fontFamily="Nunito"
              fontSize="1.3rem"
              fontWeight="bold"
              lineHeight="1.25"
            >
              {content.postTitle}
            </Title>
            <AuthorAndTime
              color="#8e8e8e"
              fontSize="0.75rem"
              fontWeight="normal"
            >
              <div>
                {content.postAuthor ? content.postAuthor.authorName : ''}
              </div>
              <div>{content.postDate}</div>
            </AuthorAndTime>
          </CardData>
        </Card>
      );
    });
  }

  // cards = null;
  return (
    <ListElement className="left-container" padding="2.25rem 1.2rem">
      <Title
        className="ttc"
        fontFamily={titleProps.fontFamily}
        fontSize={titleProps.fontSize}
        fontWeight={titleProps.fontWeight}
      >
        {title}
      </Title>
      <StyledLine>
        <StyledLineInside />
      </StyledLine>

      {/* Load Recent News Medium Like spinner instead of null in below line */}
      {cards !== null ? <CardHolder>{cards}</CardHolder> : <MainListLoader />}
      <FlexContainer alignitems="center" justifycontent="center">
        <button
          className="show-more mt4 pointer"
          style={{ background: '#4db2ec', height: '44px', width: '249px' }}
          onClick={handleLoadMore}
        >
          <Title
            color="#fff"
            fontFamily="Nunito"
            fontSize="0.8125rem"
            fontWeight="bold"
          >
            SHOW MORE
          </Title>
        </button>
      </FlexContainer>
    </ListElement>
  );
};

export default Latest;
